<template>
  <v-layout column>
    <v-data-table
      dense
      :headers="headers"
      :items="commissionTiers"
      hide-default-footer
    >
      <template v-slot:item.minAmount="{ item }">
        {{ item.minAmount | currency }}
      </template>
      <template v-slot:item.maxAmount="{ item }">
        {{ item.maxAmount | currency }}
      </template>
      <template v-slot:item.commissionPercent="{ item }">
        {{ item.commissionPercent }}%
      </template>
      <template v-slot:item.action="{ item }">
        <v-btn
          class="mx-1 my-1"
          color="primary"
          outlined
          @click="editTier(item)"
        >
          <v-icon color="primary">edit</v-icon>
        </v-btn>
        <v-btn
          class="mx-1 my-1"
          color="red"
          outlined
          @click="deleteTier(item)"
        >
          <v-icon color="red">delete</v-icon>
        </v-btn>
      </template>
    </v-data-table>
  </v-layout>
</template>

<script>
export default {
  props: [
    'commissionTiers',
    'showEditButtons'
  ],
  data () {
    return {
      headers: [
        { text: 'Min. Amount', value: 'minAmount', align: 'center', width: '25%', sortable: false },
        { text: 'Max. Amount', value: 'maxAmount', align: 'center', width: '25%', sortable: false },
        { text: 'Commission', value: 'commissionPercent', align: 'center', width: '25%', sortable: false }
      ]
    }
  },
  methods: {
    editTier (item) {
      this.$emit('editTier', item)
    },
    deleteTier (item) {
      this.$emit('deleteTier', item)
    }
  },
  mounted () {
    if (this.showEditButtons) {
      this.headers.push(
        { text: 'Actions', value: 'action', align: 'center', width: '25%', sortable: false }
      )
    }
  }
}
</script>
